import { AxiosPromise } from "axios";

import { api } from "./common";

export interface OnlyOfficeConfigResponse {
  config: Record<string, unknown>;
  token?: string;
}

export function fetchOnlyOfficeConfig(
  documentId: string,
): AxiosPromise<OnlyOfficeConfigResponse> {
  return api.get(`/onlyoffice/config/${documentId}`);
}
